<div class="bigPage">
  <ng-container *ngIf="dataRetroalimentacion">

    <div class="bigPage-cont">
      <!-- HEADER DE LA VISTA -->
      <div class="bigPage_header">
        <div class="bigPage_nav">
          <h3 class="mat-headline">{{dataRetroalimentacion.categoria}}</h3>
          <span class="spacer"></span>
          <a class="enlace-boton" [routerLink]="['/', 'estudio', 'familia', 'alumno', alumnoID, 'unidad', unidadID]"
            fragment="evidencias"><i class="material-icons">
              arrow_back
            </i><span>Volver a evidencias</span></a>
        </div>
        <div>
          <div class="bigPage_data">
            <h3 class="mat-small">Evidencia</h3>
            <p class="mat-chip-frame">{{dataRetroalimentacion.nombre}}</p>
            <!-- <h3 class="mat-small">Metas relacionadas</h3>
              <mat-chip-set>
                <mat-basic-chip *ngFor="let metaEval of evaluacionMetas">
                  {{metaEval.codigo}}-{{metaEval.id}}
                </mat-basic-chip>
              </mat-chip-set> -->
          </div>
        </div>
      </div>
      <!-- FIN HEADER DE LA VISTA -->
    </div>
    <div class="bigPage_cont">
      <div class="bigPage_content">
        <div class="bigPage_main">
          <h3 class="mat-h3">Evaluación</h3>
          <div>
            <ng-container *ngFor="let metaEval of evaluacionMetas">
              <ng-container *ngFor="let criterioEval of metaEval.criterios">
                <div class="criterio-row mat-elevation-z2">
                  <label class="full-width">{{metaEval.codigo}}-{{metaEval.id}} {{metaEval.txtFR.length > 0 ?
                  metaEval.txtFR : metaEval.txtEN.length > 0 ?
                    metaEval.txtEN : metaEval.txtES}}</label>
                  <div class="flex-wrap">
                    <div class="inline-flex criterio">
                      <h3 class="mat-small">
                        Criterio
                      </h3>
                      <mat-basic-chip style="margin: 0">{{criterioEval.nombre}}</mat-basic-chip>
                      <!-- <h3 class="mat-small">
                      Meta relacionada
                    </h3>
                    <p class="mat-basic-chip" style="margin-left: 0">
                      {{metaEval.codigo}}-{{metaEval.id}}
                    </p> -->
                    </div>
                    <div class="inline-flex" style="flex-grow: 5;">
                      <ng-container *ngFor="let nivel of criterioEval.niveles">
                        <ng-container *ngFor="let fecha of nivel.fechas">
                          <div class="">
                            <h3 class="mat-small">
                              Evaluación {{fecha.label}}
                            </h3>
                            <ng-container *ngFor="let criterioHijo of fecha.criterios">
                              <div *ngIf="criterioHijo['isSeleccionado']"
                                [ngClass]="{'logro_seleccion': criterioHijo['isSeleccionado']}" class="logro_evaluado">
                                <ng-container>
                                  <div>
                                    <p class="fist-letter-uppercase"
                                      *ngIf="criterioHijo.escala.nickName !== 'P'; else pendiente">
                                      {{criterioHijo.nombre}}</p>
                                    <ng-template #pendiente>
                                      <p>Pendiente</p>
                                    </ng-template>
                                  </div>
                                </ng-container>
                                <button mat-button
                                  (click)="openEval(metaEval.id, criterioEval.id, nivel.id, fecha.label)">
                                  Ver mi
                                  evaluación
                                </button>
                              </div>
                            </ng-container>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <div class="bigPage_aux">
          <h3 class="mat-h3">Retroalimentación</h3>
          <div *ngIf="enableComentario" class="">
            <glm-comentarios [comentarios]="comentarios" [targetID]="commentTargetID" [allowCreate]="true"
              [origen]="'unidadeventoalumno'"></glm-comentarios>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
